import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Button } from "antd";
import { PageContainer, ProCard, } from '@ant-design/pro-components';
import 'antd/dist/reset.css';
import FormDrawer from "../../components/FormDrawer";
import { CategoryForm } from "./CategoryForm";
import { CategoryApi, Configuration } from "../../api/najd";
import CategoryTable from "./CategoryTable";
import { API_URL } from "../../constants";

export const Categories = () => {
    const { t } = useTranslation();
    const { type } = useParams(); // Access the "type" parameter
    const [editMode, setEditMode] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState<any>(null);
    const [refreshTrigger, setRefreshTrigger] = useState<boolean>(false);

    const configuration = new Configuration({
        basePath: API_URL,
    });
    const categoryApi = new CategoryApi(configuration);

    const closeDrawer = () => {
        setDrawerOpen(false);
    };

    const handleRefresh = () => {
        setRefreshTrigger((prevState) => !prevState);
    };

    const onClickCreateNew = () => {
        // Handle create new action
        console.log('Click create new');
        setEditMode(false);
        setSelectedRowData({ id: null, name: null, code: null, type: type }); // Set the selected row data in the state
        console.log('set null=>', selectedRowData);
        setDrawerOpen(true);
    };

    const onClickRowEdit = (rowData: any) => {
        // Handle the row edit action
        console.log('Click editing row:', rowData);
        setEditMode(true);
        setSelectedRowData(rowData); // Set the selected row data in the state
        setDrawerOpen(true);
    };

    const onClickSubmitButton = () => {
        // Handle the row edit action
        console.log('=> onClickSubmitButton');
        if (selectedRowData) {
            handleFormSubmit(selectedRowData);
        }
    };
    // const onSubmit = (formData: any) => {
    //     // Handle the row edit action
    //     console.log('On Submit:', formData);
    // };

    // Form Events
    const handleFormSubmit = (formData: any) => {
        // Handle form submission in the parent component
        console.log('Form Data:', formData);
        if (editMode == true) {
            categoryApi.categoryUpdate(formData.id, formData)
                .then(response => {
                    // Handle the API response
                    console.log('==>categoryGetList');
                    console.log(response.data);
                    closeDrawer();
                    handleRefresh();
                })
                .catch(error => {
                    // Handle the API error
                    console.error(error);
                });
        } else {
            categoryApi.categoryCreate(formData)
                .then(response => {
                    // Handle the API response
                    console.log('==>categoryGetList');
                    console.log(response.data);
                    closeDrawer();
                    handleRefresh();
                })
                .catch(error => {
                    // Handle the API error
                    console.error(error);
                });
        }
    };
    const handleFormChange = (formData: any) => {
        console.log('handleFormChange:', formData);
        setSelectedRowData(formData);
    };
    // End Form Events
    return (
        <PageContainer
            header={{
                title: t('Categories'),
                ghost: true,
                breadcrumb: {
                    items: [
                        {
                            path: '/',
                            title: t("Home"),
                        },
                        {
                            path: '/',
                            title: t("Categories"),
                        },
                    ],
                },
                extra: [
                    (type !== 'party') ? <Button key="3" type="primary" onClick={onClickCreateNew}>
                        {t("Add New")}
                    </Button> : <></>,
                ],
            }}
        // footer={[
        //     <Button key="3">خيار 14</Button>,
        //     <Button key="2" type="primary">
        //         خيار 15
        //     </Button>,
        // ]}
        >
            <ProCard
            // style={{
            //     height: '100vh',
            //     minHeight: 800,
            // }}
            >
                <CategoryTable
                    onClickRowEdit={onClickRowEdit}
                    refreshTrigger={refreshTrigger}
                    setRefreshTrigger={setRefreshTrigger}
                    type={type}
                    />
                <FormDrawer open={drawerOpen}
                    onClose={closeDrawer}
                    formData={selectedRowData}
                    title={((editMode) ? t("Edit") : t("Create new"))}
                    onSubmit={onClickSubmitButton}>
                    <CategoryForm
                        onClose={closeDrawer}
                        formData={selectedRowData}
                        onSubmit={handleFormSubmit}
                        onChange={handleFormChange} />
                </FormDrawer>
            </ProCard>
        </PageContainer>
    );
};
